import type {
  CosmicProductType,
  CosmicVariationType,
} from '@/lib/cms/cosmic/types/CosmicProductType'

import { getTerms } from '@/lib/hooks/services/useGetTerms'
import type { GlobalStoreValues } from '@/store/useGlobalStore'

type ProductDetailEventData = {
  item_sku: string
  item_brand: string
  item_name: string
  category?: string
  price: number | null
  customer_type: string
  focused_link: boolean
}

export const generateProductDetailEventData = (
  product: CosmicProductType,
  productVariation: CosmicVariationType,
  type: string,
  globalStore: GlobalStoreValues,
): ProductDetailEventData => {
  const {
    user: { customerType },
  } = globalStore
  const price =
    (productVariation.pricing &&
      getTerms({
        pricingData: productVariation.pricing,
        forCustomerType: customerType,
      })?.priceEach) ??
    null

  const cleanObject = {
    item_sku: productVariation.sku,
    item_brand: 'Unicity',
    item_name: product.name,
    category: product.categories && product.categories[0]?.name,
    price,
    customer_type: customerType,
    focused_link: type === 'focus',
  }
  return cleanObject
}
